export const TextEffectsStripedViewerType = 'wixui.TextEffectsStriped' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsStriped-container',
    text: 'TextEffectsStriped-text',
  },
} as const;

export const angleConfig = {
  start: 0,
  end: 360,
  step: 45,
};
